var xDown, yDown;
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        // Event listeners
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });

        }
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // Disable swipe functionality on mobile
       // this.disableSwipeOnMobile();

        //swipe to correct image on mobile
        this.swipeOnMobile();
      }

      disableSwipeOnMobile() {
        if (window.matchMedia('(max-width: 749px)').matches) {
          // console.log('disableSwipeOnMobile');
          this.elements.viewer.addEventListener('touchstart', this.preventSwipe);
          this.elements.viewer.addEventListener('touchmove', this.preventSwipe);
          this.elements.viewer.addEventListener('touchend', this.preventSwipe);
        }
      }

      preventSwipe(event) {
        // event.preventDefault();
        event.stopPropagation();
       // console.log("Swipe interaction prevented.");
      }

                                                  
                                                                               
      
      swipeOnMobile() {
        if (window.matchMedia('(max-width: 749px)').matches) {
          // console.log('swipOnMobile');
          this.elements.viewer.addEventListener('touchstart', this.swipeToCorrectImageTouchStart);
          this.elements.viewer.addEventListener('touchmove', this.swipeToCorrectImage);
          this.elements.viewer.addEventListener('touchend', this.preventSwipe);
        }
      }
      
      swipeToCorrectImageTouchStart(event){
        // event.preventDefault();
        // event.stopPropagation();
        var firstTouch = event.touches ||             // browser API
               eventt.originalEvent.touches; // jQuery;
        firstTouch = firstTouch[0];
        xDown = firstTouch.clientX;                                      
        yDown = firstTouch.clientY; 
        
      //  console.log("Touch Start");
      }

      swipeToCorrectImage(evt){
        // console.log('swipeToCorrectImage');
        if ( ! xDown || ! yDown ) {
        return;
        }
    
        var xUp = evt.touches[0].clientX;                                    
        var yUp = evt.touches[0].clientY;
    
        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;

        //check if this is a horizontal swipe or a vertical swipe
        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
          evt.preventDefault();
          evt.stopPropagation();
          var activethumb = $("button.thumbnail[aria-current=true]").parent();
            if ( xDiff > 0 ) {
                /* right swipe */ 
                const next = $(activethumb).nextAll('li:visible').first();
                // console.log(next);
              next.find("button").click();
              
              
            } else {
                /* left swipe */
               var toclick = $(activethumb).prevAll('li:visible').first().find("button").click();
            }                       
        } else {
   
          //don't prevent default on vertical swipe, so that we can still scroll up/down
            if ( yDiff > 0 ) {
              
                /* down swipe */ 
            } else { 
                /* up swipe */
            }                                                                 
        }
        /* reset values */
        xDown = null;
        yDown = null;  
      }
      

      onSlideChanged(event) {
        // console.log('onSlideChanged');
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        // console.log('setActiveMedia');
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            activeThumbnail.setAttribute("variant-featured", "true");

            // const inactiveThumbnail = this.elements.thumbnails.querySelector(`.thumbnail-list_item--variant:not([data-target="${mediaId}"])`);
            // if (inactiveThumbnail != null) {
              // inactiveThumbnail.setAttribute("variant-featured", "false");
            // }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        

        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

      }

      setActiveThumbnail(thumbnail) {
        // console.log(thumbnail);
        // this.elements.thumbnails.querySelectorAll('.thumbnail-list_item--variant:not([variant-featured="true"])').forEach((element) => element.style.display = 'none');
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}